import React from "react";
import styled from "styled-components";
import {IoMdThumbsUp} from "react-icons/io";
import Rating from "../UI/Rating/Rating";
import HoverInfo from "../UI/HoverInfo/HoverInfo";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4px;
  border: 2px solid ${({theme}) => theme.colors.main};
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  background-color: ${({theme}) => theme.colors.secondary};
`;

const UserWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid ${({theme}) => theme.colors.main};
  align-items: center;
  & > p:nth-of-type(1) {
    font-weight: 500;
  }
  & > p:nth-of-type(2) {
    color: #777;
    font-size: 1.2rem;
  }
`;

const StyledRating = styled.div`
  background-color: ${({theme}) => theme.colors.main};
  border-radius: 20px;
  padding: 5px 10px;
`;

const ActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 30px;
  & > button {
    margin: 2px 2px;
    font-size: 2rem;
    border: none;
    background: none;
    position: relative;
    &:hover {
    }
  }
`;

const CommentItem: React.FC<any> = ({data}) => (
  <Wrapper>
    <UserWrapper>
      <p>Username</p>
      <p>{data.comment_date}</p>
      <StyledRating>
        <Rating currRating={data.rate} />
      </StyledRating>
    </UserWrapper>
    <p>{data.content}</p>
    <ActionWrapper>
      <button>
        <HoverInfo info="Likes">
          8
          <IoMdThumbsUp />
        </HoverInfo>
      </button>
      <button>Reply</button>
    </ActionWrapper>
  </Wrapper>
);

export default CommentItem;
